// src/Cancel.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { deletePendingOrder } from "./firestore";
import './Success.css'; // Réutilise le même style que Success

export default function Cancel() {
  const navigate = useNavigate();
  const [cleaned, setCleaned] = useState(false);

  useEffect(() => {
    const cleanup = async () => {
      const params = new URLSearchParams(window.location.search);
      const userId = params.get("uid");

      if (userId) {
        try {
          // Supprimer la pendingOrder — le panier Firebase reste intact
          // Le client peut relancer le paiement directement depuis son panier
          await deletePendingOrder(userId);
        } catch (error) {
          console.error("Erreur lors du nettoyage de la pendingOrder :", error);
        }
      }

      setCleaned(true);
    };

    cleanup();
  }, []);

  return (
    <div className="success-page">
      <div className="success-content">
        <h2>❌ Paiement annulé</h2>
        <p>
          Votre paiement n'a pas été finalisé.<br />
          <strong>Votre panier est conservé</strong>, vous pouvez réessayer à tout moment.
        </p>
        <button
          className="success-home-btn"
          onClick={() => navigate("/")}
          disabled={!cleaned}
        >
          Retour à la boutique
        </button>
      </div>
    </div>
  );
}
